import React from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page } from '@syncfusion/ej2-react-grids';
import { modelPerformanceData } from '../data/dummy';

const ModelPerformance = () => {
  const toolbarOptions = ['Search'];
  const editing = { allowDeleting: true, allowEditing: true };

  return (
    <div>
      <div className="m-1 md:m-1 p-1 md:p-5 bg-white rounded-3xl">
        <GridComponent
          dataSource={modelPerformanceData}
          width="auto"
          editSettings={editing}
          toolbar={toolbarOptions}
        >
          <ColumnsDirective>
            <ColumnDirective field="metric" headerText="Metric" textAlign="Left" width="120" isPrimaryKey={true} />
            <ColumnDirective field="KoGPT" headerText="KoGPT" textAlign="Center" width="240" />
            <ColumnDirective field="KoBERT" headerText="KoBERT" textAlign="Center" width="240" />
            <ColumnDirective field="KcBERT" headerText="KcBERT" textAlign="Center" width="240" />
            <ColumnDirective field="KlueBERT" headerText="KlueBERT" textAlign="Center" width="240" />
            <ColumnDirective field="KoELECTRA" headerText="KoELECTRA" textAlign="Center" width="240" />
          </ColumnsDirective>
          <Inject services={[Search, Page]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default ModelPerformance;
